import React from 'react';
import { usePrdStore } from '../store/prd-store';
import { exportToMarkdown } from '../utils';
import MarkdownIt from 'markdown-it';

const md = new MarkdownIt({
  html: true,
  linkify: true,
  typographer: true,
});

export const EditorPreview: React.FC = () => {
  const { document } = usePrdStore();

  if (!document) return null;

  const markdown = exportToMarkdown(document);
  const html = md.render(markdown);

  return (
    <div className="prd-preview h-full overflow-y-auto bg-white dark:bg-gray-800">
      <div className="max-w-4xl mx-auto p-8">
        <article 
          className="prose prose-lg dark:prose-invert max-w-none"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </div>
    </div>
  );
};